import React, { Component } from 'react';
import InputMask from 'react-input-mask';

class DatePicker extends Component {
    constructor(props) {
        super(props);

        this.attachDatepicker = this.attachDatepicker.bind(this);

        this.state = {
            loading_datepicker: true,
        };
    }

    componentDidMount() {
        this.attachDatepicker(); 
    }

    setInputRef(element) {
        if(!this.props.inputRef.current){
            this.props.inputRef.current = element;
        }
    }

    attachDatepicker() {
        var self = this;

        self.setState({
            loading_datepicker: false
        })
        
        $("#" + self.props.id).datepicker({
            dateFormat: 'mm-dd-yy',
            minDate: ("mindate" in this.props && this.props.mindate ? (new Date(this.props.mindate)) : null),
            maxDate: ("maxdate" in this.props && this.props.maxdate ? (new Date(this.props.maxdate)) : null),
            ignoreReadonly: true,
            allowInputToggle: true,
            onSelect: function(date) {
                self.props.onChange({target: {type: "text", name: self.props.name, value: date}});
            },
            beforeShow: function (input, inst) {
                $(this).blur();
                if("attach_to_input" in self.props && self.props.attach_to_input) {
                    setTimeout(function () {
                        inst.dpDiv.css({
                            top: $("#" + self.props.id).offset().top + 35,
                            left: $("#" + self.props.id).offset().left
                        });
                    }, 0);
                }
            },
        });
        
    }

    render() {
        return (
            <InputMask
                mask="99-99-9999"
                value={this.props.value}
                onChange={this.props.onChange}
                {...this.props}>
                    {(inputProps) => <input ref={this.props.inputsRef} {...inputProps}/>}
            </InputMask>
        );
    }
}

export default DatePicker;